import React, { useEffect } from "react";
import { MultiStepItemProps } from "@ucl/library";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { AppToasterV2 } from "@ucl/library";
import { FinancialApplicationSection } from "@/types/enums";
import {
  useFinancialApplicationFormSectionValidation,
  FinancialApplicationFormValidationDisplayBehavior,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { FinancialApplicationDocumentsForm } from "./FinancialApplicationDocumentsForm";

export interface FinancialApplicationDocumentsFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const FinancialApplicationDocumentsFormStep: React.FC<
  FinancialApplicationDocumentsFormStepProps
> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <FinancialApplicationDocumentsFormStepInner {...props} />
    </RequireAuth>
  );
};

const FinancialApplicationDocumentsFormStepInner: React.FC<
  FinancialApplicationDocumentsFormStepProps
> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.FinancialApplicationDocuments
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection, props.registerSubmit]);

  return (
    <section className="financial-application-documents step-section">
      <div className="financial-application-documents__header step-header">
        Application Documents
      </div>
      <div className="financial-application-documents__subtitle step-subtitle">
        Please upload the required documents for your application.
      </div>
      <div className="financial-application-documents-form__content step-content">
        <FinancialApplicationDocumentsForm
          financialApplicationId={props.financialApplicationId}
          autoValidationBehavior={
            FinancialApplicationFormValidationDisplayBehavior.NeverDisplayValidationErrors
          }
          showHeader={false}
        />
      </div>
    </section>
  );
};
